import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from "./components/Footer";
import Homepage from "./components/Homepage";
import Navigation from "./components/Navigation";
import Posts from "./components/Posts";
import NewPostForm from "./components/NewPostForm";
import PostComments from "./components/PostComments";
import WasherSignup from "./components/WasherSignup";
import WearerSignup from "./components/WearerSignup";
import Login from "./components/Login";

function App() {
  return (
    <Router>
      <Navigation /> {/* Navigation bar always at the top */}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/feed" element={<Posts />} />
        <Route path="/posts/:postId" element={<PostComments />} />
        <Route path="/new-post" element={<NewPostForm />} />
        <Route path="/washer-signup" element={<WasherSignup />} />
        <Route path="/wearer-signup" element={<WearerSignup />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      <Footer /> {/* Footer always at the bottom */}
    </Router>
  );
}

export default App;
